import React, {
  useState,
  useEffect,
  useCallback,
  useMemo,
  useRef,
} from 'react';

import PropTypes from 'prop-types';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';

import { format, subDays, setHours, setMinutes, setSeconds, parseISO } from 'date-fns';
import { t, parseDateString } from '~/helpers';
import { number } from '~/helpers';

import * as S from '../TableStyles/styles';

import { Form, Input, Autocomplete } from '~/components/Form';

import { UnidataTable } from '~/components';

import history from '~/services/history';

import { Button } from '@material-ui/core';

import { isEmpty, isNull, isNumber } from 'lodash';
import * as Yup from 'yup';

import { recordFiltering } from '~/store/modules/servicedlgrelestoque/actions';
import { resetParams } from '~/store/modules/hooks/actions';

import api from '~/services/api';

export default function FormRelAbastecimento({ params, sending, close }) {

  const formRef = useRef(null);


  const [open, setOpen] = useState(true);

  const [tiposAgenda, setTiposAgenda] = useState([]);

  const dispatch = useDispatch();

  const reference = useRef(null);

  const [showTable, setShowTable] = useState(false);

  const [valor_tiag_nome, setValor_tiag_nome] = useState('');
  const [muLocalidade, setMuLocalidade] = useState({
    mula_codigo: '',
    mula_desc_localidade: '',
  });

  const data = useSelector((state) => state.servicedlgrelestoque);


  useEffect(() => {
    if (params) {
      formRef.current.setData({ ...params });
    }
  }, [params]);


  const datahorainicial = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(subDays(new Date(), 7), 0), 0), 0),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );
  const datahorafinal = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(new Date(), 23), 59), 59),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );


  const handleSubmit = useCallback(
    async (dataForm) => {
      try {
        //   const schema = Yup.object().shape({
        //     unid_nome: Yup.string().required(
        //       t('s.geral.validacao.campoobrigatorio')
        //     ),
        //     unidade_origem: Yup.string().required(
        //       t('s.geral.validacao.campoobrigatorio')
        //     ),
        //     prod_codigo: Yup.string().required(
        //       t('s.geral.validacao.campoobrigatorio')
        //     ),
        //     cota: Yup.number()
        //       .required(t('s.geral.validacao.campoobrigatorio'))
        //       .min(0, t('s.geral.validacao.tamanhominimo').replace('%s', 0))
        //       .max(
        //         balance,
        //         t('s.geral.validacao.tamanhomaximo').replace('%s', balance)
        //       ),
        //   });

        //   await schema.validate(dataForm, {
        //     abortEarly: false,
        //   });

        //   const dataSendForm = {
        //     orga_codigo_origem: unity.orga_codigo,
        //     unid_codigo_origem: unity.unid_codigo,
        //     orga_codigo_destino: data.orga_codigo,
        //     unid_codigo_destino: data.unid_codigo,
        //     usua_login: unity.usua_login,
        //     prod_codigo: dataForm.prod_codigo,
        //     cota: dataForm.cota,
        //   };

        //   await api.put('cotaunidade/transferencia', dataSendForm);

        //   toast.success('Atualizado com sucesso!');

        //   await close();
      } catch (err) {
        //   const validationErrors = {};

        //   if (err instanceof Yup.ValidationError) {
        //     err.inner.forEach((error) => {
        //       validationErrors[error.path] = error.message.replace(
        //         `${error.path} `,
        //         ''
        //       );
        //     });

        //     formRef.current.setErrors(validationErrors);
        //   }
      }
    },
    [params]
  );

  useEffect(() => {
    if (sending) formRef.current.submitForm();
  }, [sending]);

  const handleDispatch = useCallback(async (params) => {
    setShowTable(true);

    let wherefield = [];
    let valuewherefield = [];
    let typewherefield = [];

    for (let item in params) {
      if (
        (!isEmpty(params[item]) || isNumber(params[item])) &&
        item != 'tipo'
      ) {
        wherefield.push(item);
        valuewherefield.push(params[item]);
        if (item == 'datahorainicial' || item == 'datahorafinal') {
          item == 'datahorainicial'
            ? typewherefield.push('MAIOR_IGUAL')
            : typewherefield.push('MENOR_IGUAL');
        } else {
          typewherefield.push('EQUALS');
        }
      }
    }

    await dispatch(
      recordFiltering({
        page: 1,
        pagesize: 10,
        wherefield: [...wherefield],
        valuewherefield: [...valuewherefield],
        typewherefield: [...typewherefield],
      })
    );
  });

  const header = useMemo(() => [
    {
      id: 'resp',
      label: 'Responsável',
      filter: {
        type: 'text',
      },
    },
    {
      id: 'post_desc',
      label: 'Posto',
      filter: {
        type: 'text',
      },
    },
    {
      id: 'potr_data_trans',
      label: 'Última Transmissão',
      formatted: (value) => (value !== null ? moment(value).format('DD/MM/YYYY HH:mm') : '-'),
      align: 'left',

    },
    {
      id: 'tavi_capacidade',
      label: 'Capacidade Tanque',
      align: 'right',
      formatted: (value) => number(value, 1),
    },
    {
      id: 'tavi_vol',
      label: 'Estoque Tanque',
      align: 'right',
      formatted: (value) => number(value, 1),
    },

    {
      id: 'qtd',
      label: 'Qde Pátio',
      align: 'right',
      formatted: (value) => number(value, 1),
    },
    {
      id: 'volume',
      label: 'Volume Pátio',
      align: 'right',
      formatted: (value) => number(value, 1),
    },

    {
      id: 'total',
      label: 'Estoque no Posto Total',
      align: 'right',
      formatted: (value) => number(value, 1),
    },

    {
      id: 'C_StatusLinha',
      label: 'Status Transmissão Central',
      styled: (v) => (v === 'Transmissão Atrasada' ? { color: 'red' } : { color: 'green' }),
    },
  ], []);

  const handleReopenForm = useCallback(() => {
    setOpen(true);
    setShowTable(false);
  }, []);


  return (

    <>
      {/* {JSON.stringify(params)} */}

      {(params) &&
        <Form ref={formRef} onSubmit={handleSubmit} initialData={params}>
          <Input name="veic_placa" label="Placa do Veículo" />

          <Input name="agen_codigo" label="Número Agenda" type="number"/>
        </Form>
      }


      <UnidataTable
        dense
        fixed
        maxHeight={300}
        create={false}
        update={false}
        delete={false}
        header={header}
        redux={data}
        read={recordFiltering}
        detach="veic_placa"
        keys="veic_placa"
      />
    </>


  );
}

FormRelAbastecimento.propTypes = {
  params: PropTypes.objectOf(PropTypes.any).isRequired
}
